export default __webpack_public_path__ + "static/media/service-icon-3A.45e60f69.png";